import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';

import NeatixModal from '@components/Modal/NeatixModal';
import useGetFACategoriesList from '@hooks/FixedAssets/useGetFACategoriesList';
import AddFaCategory from './AddFaCategory';
import NtxTable from '@components/DataTable/NtxTable';

const Index = () => {
  const [showAddModal, setShowAddModal] = useState(false);

  const { t, i18n } = useTranslation();

  const { FACategoriesList: data, loading, error } = useGetFACategoriesList();

  const columns = [
    { title: t('Name'), key: 'name' },
    { title: t('الفئة الرئيسية'), key: 'parent' },
    { title: t('Icon'), key: 'icon' },
    { title: t('العمر بالشهور'), key: 'age' },
    { title: t('طريقة الإهلاك'), key: 'dpr' },
    { title: t('نسبة الإهلاك'), key: 'presntage' },
    { title: '', key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = data?.map(item => {
    let rowClass;

    return {
      name: i18n.language === 'en' ? item.name : item.name2,
      parent:
        i18n.language === 'en'
          ? item.categoryName
            ? item.categoryName
            : 'Main Category'
          : item.categoryName2
          ? item.categoryName2
          : 'فئة رئيسية',
      icon: (
        <div className='text-theme fs-4'>
          <i className={item.icon}></i>
        </div>
      ),
      age: item.lifeInMonths,
      dpr: item.depreciationMethod,
      presntage: item.percentage,
      action: (
        <div>
          {/* زر التعديل */}
          <button type='button' className='btn  btn-outline-theme mx-1'>
            <i className='far fa-lg fa-fw fa-edit'></i>
          </button>

          {/* زر المشاهدة */}
          <button type='button' className='btn  btn-outline-primary mx-1'>
            <i className='far fa-lg fa-fw fa-eye'></i>
          </button>

          {/* زر الحذف */}
          <button type='button' className='btn  btn-outline-danger mx-1'>
            <i className='far fa-lg fa-fw fa-trash-alt'></i>
          </button>
        </div>
      )
    };
  });

  //____________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'فئات الأصـول',
              link: null
            }
          ]}
          PageName='فئات الأصـول'
        />

        <div className='ms-auto'>
          <Link
            // to="AddFaCategory"
            to=''
            className='btn me-1 btn-theme'
            onClick={() => setShowAddModal(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            فئة جديــدة
          </Link>
        </div>
      </div>
      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <NeatixModal
        show={showAddModal}
        setShow={setShowAddModal}
        // bodyClassName="p-0"
        title='إضــافة فئة جديـدة'
        size='xl'
        // showHeader={false}
      >
        <AddFaCategory onClose={() => setShowAddModal(false)} />
      </NeatixModal>
    </div>
  );
};

export default Index;
